import * as stylex from "@stylexjs/stylex";
import { useId } from "react";
import { copy } from "@/copy";
import { formatLongWeekday, formatMonthDay, formatWeekday } from "@/domain/time";
import { parseDateKey } from "@/domain/zone";
import { Button } from "@/ui/Button";
import { Dialog } from "@/ui/Dialog";
import { Eyebrow } from "@/ui/Eyebrow";
export type SeriesDialogProps = {
  kind: "delete" | "save";
  title: string;
  day: string;
  onOne: () => void;
  onAll: () => void;
  onCancel: () => void;
};
const text = copy.events.series;
const styles = {
  card: {
    ks0D6T: "x1lwm3bp",
    kOIVth: "x33pbmt",
    kLKAdn: "xl76xaq",
    kg3NbH: "x1eq97yh",
    kGO01o: "x17du0tb",
    $$css: true
  }
};
export function SeriesDialog({
  kind,
  title,
  day,
  onOne,
  onAll,
  onCancel
}: SeriesDialogProps) {
  const titleId = useId();
  const date = parseDateKey(day);
  const weekday = formatLongWeekday(date, "UTC");
  const name = title.trim() || text.untitled;
  const when = `${formatWeekday(date, "UTC")}, ${formatMonthDay(date, "UTC")}`;
  const deleting = kind === "delete";
  return <Dialog labelledBy={titleId} xstyle={styles.card} onClose={onCancel}>
      <div className="x78zum5 xdt5ytf x1v2ro7d">
        <Eyebrow>{text.eyebrow(weekday)}</Eyebrow>
        <h2 id={titleId} className="x1ghz6dp xufd9wi xfbjfs5 xcwzsbu x1159mfc x1fzhlzt">
          {deleting ? text.deleteTitle : text.saveTitle}
        </h2>
        <p className="x1ghz6dp xosj86m x15i68ds xfrs9s4 x1fzhlzt">
          {deleting ? text.deleteBody(name, weekday, when) : text.saveBody(name, weekday, when)}
        </p>
      </div>
      <div className="x78zum5 xdt5ytf x1v2ro7d">
        <Button variant="secondary" fullWidth onClick={onOne}>
          {text.one}
        </Button>
        <Button variant={deleting ? "danger" : "primary"} fullWidth onClick={onAll}>
          {text.all}
        </Button>
        <Button variant="ghost" fullWidth onClick={onCancel}>
          {deleting ? text.keepEvent : text.keepEditing}
        </Button>
      </div>
    </Dialog>;
}